import styled from "styled-components";

const CardContainer = styled.div`
  border-radius: 23px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.16);
  background: linear-gradient(180deg, #69bbe0 27%, #ffffff 27%);
  text-align: center;
  padding: 12px;
  min-width: 231px;
  min-height: 324px;
  display: grid;
  grid-template-rows: auto auto 1fr;
  .card-header-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    p {
      font-size: 15px;
      font-family: "latobold";
      margin: 0;
      padding: 0 6px;
      border-radius: 4px;
    }
    .member-tag {
      background: linear-gradient(to bottom, #61b01f 0%, #27911b 100%);
    }
    .group-tag {
      background: #00446e;
    }
    span {
      font-size: 13px;
    }
  }
  .image-wraper {
    width: 99px;
    height: 99px;
    border-radius: 50%;
    margin: 0 auto 20px;
    overflow: hidden;
    background: #fff;
    object-fit: cover;
    margin-top: 11px;
    img {
      width: 99px;
      height: 99px;
      object-fit: cover;
    }
  }
  .group-icon {
    min-width: 133px;
    max-width: 133px;
    min-height: 82px;
    max-height: 82px;
    border-radius: 0;
    box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
    background-color: #fff;
    img {
      max-width: 100%;
      object-fit: contain;
    }
  }
  .privatePost {
    background: #ff6008;
    font-size: 12px;
    line-height: 1.67;
    color: #ffffff;
    padding: 0 6px;
    margin: 0 10px;
  }
  .text-detail {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    /* gap: 3px; */
    button {
      padding-left: 10px;
      padding-right: 10px;
    }
    .privateBtnDisabled {
      cursor: none;
      color: #dcdcdc;
    }
    h2 {
      font-size: 19px;
      font-family: "latobold";
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 200px;
      margin-bottom: 11px;
    }
    h3 {
      font-size: 19px;
      margin-bottom: 5px;
      display: flex;
    align-items: flex-start;
    gap: 3px;
    text-align: left;
    }
    h4 {
      font-size: 12px;
      display: flex;
    align-items: center;
    gap: 3px;
    }
    h5 {
      font-size: 14px;
    }
    h6 {
      font-size: 12px;
      display: flex;
    align-items: center;
    gap: 3px;
    }
    button {
      
      font-size: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 25px;
      border-radius: 4px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      border: solid 1px #dcdcdc;
      background-image: linear-gradient(to bottom, #66a1c6, #3a6683);
      color: #fff;
      margin-top: 22px;
    }
    .group-company-name {
      font-size: 14px;
      word-break: break-all;
    }
    .company-name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
      max-width: 20ch
    }
    .group-name {
      margin-bottom: 2px;
    }
    .group-location-name {
      font-size: 11px;
      line-height: 13px;
    }
  }
`;

const CardWrapper = styled.div`  
  position: relative;
  .card-box-wrapper{
    padding: 20px;
    align-items: center;
    grid-gap: 40px 80px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(231px, 1fr));
    max-height: 600px;
    overflow-y: auto;
    margin-bottom: 10px;
  }
  @media (max-width:767px) {
    .card-box-wrapper{
      grid-template-columns: 1fr 1fr;
      grid-gap: 18px;
    }
  }
`;

export { CardContainer, CardWrapper };
